import React from 'react'

export default function DrawIcon({ color = null }) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path
        d="M17.907.476c.39.39.56.844.54 1.35-.107 2.512-4.772 7.114-8.33 10.26-.23-.624-.61-1.31-1.203-2.05l-.083-.094c-.77-.77-1.624-1.298-2.522-1.55C9.178 5.14 14.034.104 16.608 0c.53-.012.962.145 1.3.474zM7.86 10.912l.043.047c1.12 1.405 1.436 2.68.94 3.786-1.238 2.76-7.116 3.16-7.783 3.195L0 18l.594-.882c.01-.015 1.01-1.525 1.01-4.105 0-1.362.89-2.686 2.164-3.218C5.09 9.24 6.583 9.65 7.86 10.912z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
